import {FeedItemContextType} from "components/feed/FeedItem/FeedItem";

declare var $:any;

import {TextQuestion} from "components/quiz/TextQuestion";
import {observer} from "mobx-react";
import * as React from "react";
import {PUT_QUERY} from "utils";
import {RangeSelectorNumeric} from "components/quiz/RangeSelectorNumeric";
import {RangeSelectorValue} from "components/quiz/RangeSelectorValue";
import {CheckboxQuestion} from "components/quiz/CheckboxQuestion";
import {computed, observable} from "mobx";
import {RadioQuestion} from "components/quiz/RadioQuestion";
import {UserAnswer} from "components/quiz/UserAnswer";
import {createRef} from "react";

import './InlineQuiz.pcss';

interface IInlineQuizProps {
  feedItem: any;
  updateFeedItem: (feedItem: any) => void;
  feedItemContext:FeedItemContextType;
}


@observer
export class InlineQuiz extends React.Component<IInlineQuizProps> {
  @observable userAnswers:UserAnswer[] = [];

  constructor(props:IInlineQuizProps) {
    super(props);

    // Create a UserAnswer for each step
    props.feedItem._post.steps.forEach((step:any)=>{

      const userAnswer = {
        step:step,
        answerValue:'',
      };

      // extract a saved answer value if there is one
      if(props.feedItem.data) {
        const answer = props.feedItem.data.find((datum)=>datum.stepId===step._id);
        if(answer) {
          userAnswer.answerValue = ''!==answer.answerValue ? answer.answerValue : '';
        }
      }

      // add the answer to the answers array
      this.userAnswers.push(userAnswer);
    })
  }

  submitAnswers = () => {

    if(!this.quizComplete) {
      alert('Answers cannot be submitted until all questions are answered.');
    } else {

      const feedItem = this.props.feedItem;
      const feedItemUpdates: any = {
        data: [],
      };

      this.userAnswers.forEach((userAnswer) => {
        feedItemUpdates.data.push({stepId: userAnswer.step._id, answerValue: userAnswer.answerValue});
      });


      // TODO: move to server
      feedItemUpdates.completed = true;
      feedItemUpdates.read = true;
      feedItemUpdates.pointsAwarded = feedItem._post.pointValue;
      feedItemUpdates.pointsAwardedDate = new Date();
      feedItemUpdates.displayEndDate = "null";	// now that this is a "points" object, we make sure it does not go away.
      feedItemUpdates.step = this.props.feedItem._post.steps.length;  // Indicate finished state

      // TODO: move to datastore
      $.ajax(PUT_QUERY("/feed/items/" + this.props.feedItem._id, feedItemUpdates))
        .done((_feedItem) => {
          feedItem.step = _feedItem.step;
          feedItem.data = _feedItem.data;
          feedItem.pointsAwarded = _feedItem.pointsAwarded;
          feedItem.pointsAwardedDate = _feedItem.pointsAwardedDate;
          feedItem.read = _feedItem.read;
          this.props.updateFeedItem(feedItem);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          alert('Something went wrong. The Internet might be unavailable or unstable. Please try again!');
        });
    }
  }

  /**
   * All questions are answered, and correct
   */
  @computed get quizComplete() {
    for(let i=0;i<this.userAnswers.length;i++) {
      const userAnswer = this.userAnswers[i];
      if(userAnswer.step.type!=='information' && userAnswer.step.type!=='text' ) {
        if(userAnswer.answerValue==='' || (userAnswer.step.hasCorrectAnswer && userAnswer.step.correctAnswer !== userAnswer.answerValue)) {
          return false;
        }
      }
    }
    return true;
  }

  @computed get answersLocked() {
    return this.props.feedItem.pointsAwardedDate ? true : false;
  }

  @computed get status() {
    let answerable = 0;
    let answered = 0;
    for(let i=0;i<this.userAnswers.length;i++) {
      const userAnswer = this.userAnswers[i];
      if(userAnswer.step.type!=='information' && userAnswer.step.type!=='text' ) {
        answerable++;
        if(userAnswer.answerValue!=='') {
          if (userAnswer.step.hasCorrectAnswer) {
            if (userAnswer.step.correctAnswer === userAnswer.answerValue) {
              answered++;
            }
          } else {
            answered++;
          }
        }
      }
    }
    if(answered===answerable) {
      if(this.props.feedItem._post) {
        if(this.answersLocked) {
          return `${this.props.feedItem._post.title} completed!${this.props.feedItem._post.pointValue?" You have earned "+this.props.feedItem._post.pointValue+" point"+(this.props.feedItem._post.pointValue==1?"":"s")+".":''}`;
        } else {
          return `${this.props.feedItem._post.title} ready to submit${this.props.feedItem._post.pointValue?" for "+this.props.feedItem._post.pointValue+" point"+(this.props.feedItem._post.pointValue==1?"":"s")+".":''}`;
        }
      } else {
        return "You have completed all questions!";
      }
    } else {
      return "You have completed " + answered + " out of " + answerable + " required questions.";
    }
  }

  render() {

    const feedItem = this.props.feedItem;
    if (feedItem.step >= feedItem._post.steps.length) {
      return null;
    }
    return (
      <table className={'inlineQuiz'}>
        <tbody>
        <tr>
          <td>
            {feedItem._post.steps.map(step=><Question key={step._id} step={step} userAnswers={this.userAnswers} answerLocked={this.answersLocked} feedItemContext={this.props.feedItemContext} />)}

            <p role="status" aria-live="polite">{this.status}</p>
            <button tabIndex={0} className={`submit ${this.answersLocked?'submitted':''}`} onClick={this.submitAnswers}>
              {this.answersLocked ? 'Answers Submitted': 'Submit Your Answers'}
            </button>

            {/*{this.answersLocked && <div dangerouslySetInnerHTML={{__html: feedItem._post.content}}></div> }*/}

          </td>
        </tr>
        </tbody>
      </table>
    );

  }
}

interface QuestionProps {
  answerLocked:boolean;
  step:any;
  userAnswers:any[];
  feedItemContext:FeedItemContextType;
}

const Question = observer((props:QuestionProps) => {
  const {step} = props;

  const userAnswer = props.userAnswers.find(userAnswer => userAnswer.step._id === step._id);

  let quizQuestion: any = "";

  const questionId = 'question-' + step._id;

  if (userAnswer) {
    if (step.type == 'question') {
      quizQuestion = <RadioQuestion userAnswer={userAnswer} answerLocked={props.answerLocked} questionId={questionId} />;
    } else if (step.type == 'numeric range') {
      quizQuestion = <RangeSelectorNumeric userAnswer={userAnswer} />;
    } else if (step.type == 'value range') {
      quizQuestion = <RangeSelectorValue userAnswer={userAnswer} />;
    } else if (step.type == 'text') {
      quizQuestion = <TextQuestion userAnswer={userAnswer} />;
    } else if (step.type == 'checkboxes') {
      quizQuestion = <CheckboxQuestion userAnswer={userAnswer} />;
    }
  }

  return (
    <fieldset>
    <div className={`q-question${props.answerLocked?' q-complete':''}`} >
      <div className={'question-top-text'}>
        {'information'===step.type ?
          <p>{step.content}</p>
          :
          <legend>{'bundle-feed'===props.feedItemContext ? <h3 className={'level3'} id={questionId}>{step.content}</h3> : <h4 className={'level3'}  id={questionId}>{step.content}</h4>}</legend>
        }
      </div>
      {quizQuestion}
    </div>
    </fieldset>
  )

});
